import { Typography, Box } from "@mui/material";
import Article from "../../common/Article/Article";
import PropTypes from "prop-types";
import styles from "./Resources.module.css";

// Article data array
const articlesData = [
  {
    id: "1",
    image: "/start-at-sprint-game-isolated-runner@2x.png",
    heading: "Getting started",
    text: "Begin your journey by setting up your profile and uploading your first images to share with your fans.",
    link: "/help/getting-started/what-is-mementomaster"
  },
  {
    id: "2",
    image: "/an-image-of-a-crowd-of-supporters@2x.png",
    heading: "Maximizing Your Reach",
    text: "Learn how to engage your audience and turn your most memorable moments into a new revenue stream.",
    link: "/help/using-memorymaster/share-memories-on-platforms"
  },
  {
    id: "3",
    image: "/futuristic-online-transactions-made-with-ease@2x.png",
    heading: "Seamless Transactions",
    text: "Sell your images effortlessly with built-in tools for pricing, licensing, and secure payments.",
    link: "help/getting-started/create-first-memory"
  }
];

const Resources = ({ className = "" }) => {
  return (
    <section className={[styles.resourcesSection, className].join(" ")}>
      <Typography className={styles.resourcesTitle} component="h1">
        Resources for getting started
      </Typography>
      <Box className={styles.articlesContainer}>
        <Box className={styles.articlesGrid}>
          {articlesData.map(article => (
            <Article
              key={article.id}
              id={article.id}
              link={article.link}
              image={article.image}
              heading={article.heading}
              text={article.text}
            />
          ))}
        </Box>
      </Box>
    </section>
  );
};

Resources.propTypes = {
  className: PropTypes.string,
};

export default Resources;